import styled from 'styled-components'

export const Container = styled.section`
  align-items: center;
  background-color: #62C1D0;
  display: flex;
  justify-content: center;
  padding: 62px 32px;
  width: 100%;
`

export const Content = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
  max-width: 1240px;
  width: 100%;

  figure {
    margin-left: -4%;
  }

  @media (max-width: 950px) {
    flex-direction: column;
    max-width: 613px;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  max-width: 509px;

  h1, h4, p, span {
    color: var(--white);
  }

  @media (max-width: 1180px) {
    max-width: 450px;
  }
`

export const LogoContainer = styled.div`
  align-items: center;
  background-color: var(--white);
  border-radius: 8px;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, .08);
  display: flex;
  justify-content: center;
  padding: 8px 16px;
  width: fit-content;
`

export const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  h1 {
    font-size: 32px;
    line-height: 40px;
  }

  p {
    line-height: 24px;
  }

  @media (max-width: 950px) {
    h1 {
      font-size: 24px;
      line-height: 32px;
    }
  }
`

export const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  span small {
    font-size: 11px;
    line-height: 12px;
    }

    @media (max-width: 950px) {
      h4 span,
      span small {
        display: none;
      }
    }
`

export const PriceContainer = styled.div`
  align-items: center;
  background-color: var(--white);
  border-radius: 10px;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  padding: 16px;
  max-width: 300px;
  width: 100%;

  p {
    color: var(--black);
    font-size: 14px;
    line-height: 16px;
    max-width: 183px;

    small {
      font-size: 10px;
      line-height: normal;
    }

    &:has(span) {
      font-size: 14px;
      line-height: 28px;
      white-space: nowrap;

      &, span {
        color: #62C1D0;
        vertical-align: top;
      }

      span {
        font-size: 48px;
        font-weight: 700;
        line-height: 48px;
      }
    }
  }
`

export const CarouselContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  width: 100%;
`
